function updateHeaderCartCount(count) {
  const countElement = document.getElementById('cart-count')
  countElement.textContent = count
  if (count === 0) {
    countElement.classList.add('hidden')
  } else {
    countElement.classList.remove('hidden')
  }
}

//this is required to deal with the scenario where a user increments/decrements the quantity quickly
function debounce(func, timeout = 500) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

//add product to cart
document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    //prevent normal submission
    event.preventDefault()

    //submit form with ajax
    await fetch('/cart/add', {
      method: 'post',
      body: new FormData(form)
    })

    await updateCartDrawer()
    await new Promise((x) => setTimeout(x, 100)) //this is used to ensure the open-cart transition works. without it the transition is skipped
    openCartDrawer()

    //Get new cart object
    const res = await fetch('/cart.json')
    const cart = await res.json()

    updateHeaderCartCount(cart.item_count)

    //notification below 'add to basket' button
    form.querySelector('.added-to-cart').classList.add('active')
  })
})

function openCartDrawer() {
  document.getElementsByTagName('html')[0].classList.add('cart-open')
}

document
  .getElementById('open-cart-drawer')
  .addEventListener('click', function () {
    openCartDrawer()
  })
